import { BrodCrampWrapper } from "styles/jss/ProductsPage.styles";
import { useRouter } from "next/router";

const ProductBrodCramp = ({ name }) => {
  const { locale, query } = useRouter();
  return (
    <BrodCrampWrapper locale={locale}>
      Products/{query.type}/ <span>{name}</span>
    </BrodCrampWrapper>
  );
};

export default ProductBrodCramp;
